// removed by extract-text-webpack-plugin
module.exports = {"mobileFeaturedImg":"src-components-project-project-hero-project-hero-image----project-hero-image-module---mobileFeaturedImg---2YV_j","desktopFeaturedImg":"src-components-project-project-hero-project-hero-image----project-hero-image-module---desktopFeaturedImg---2H4Ym","desktopFeaturedImgIE":"src-components-project-project-hero-project-hero-image----project-hero-image-module---desktopFeaturedImgIE---3r6la","mobileFeaturedImgIE":"src-components-project-project-hero-project-hero-image----project-hero-image-module---mobileFeaturedImgIE---3Lg0P"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project/project-hero/project-hero-image/project-hero-image.module.css
// module id = 517
// module chunks = 168707334958949